import Constants from "const/Constants";
import DateTimeFormats from "const/DateTimeFormats";
import React from "react";
import moment from "moment";

const IssueDateCell = ({ documentData: { issueDate } }) => {
  return (
    issueDate ? moment.utc(issueDate).format(DateTimeFormats.DATE_TEXT) : Constants.EMPTY_PLACEHOLDER
  );
};

export default React.memo(IssueDateCell);
